module.exports = __webpack_public_path__ + "static/benjamin_k.f58b6dea.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/reviews/benjamin_k.png
// module id = 1713
// module chunks = 35783957827783